<template>
  <div class="container">
    <div class="g-p-15 g-flex">
      <!--   理论笔试   -->
      <div class="exam-item ">
        <div class="g-flex g-row-center">
          <div class="g-text-center">
            <img src="@/assets/examination/llbs-img.png" class="g-m-t-75 exam-title" alt="">
            <div>
              <img src="@/assets/examination/exam-cut-line.png" class="bar-line" alt="">
            </div>
            <div class="g-m-t-20">
              <img src="@/assets/examination/exam-box-bar.png" class="box-bar" alt="">
              <div class="info-box g-rela">
                <!--   不合格图片   -->
                <img src="@/assets/examination/failed-icon.png" class="res-icon" alt="" v-if="examDetailData.writtenTest*1 === 2">
                <!--   合格图片   -->
                <img src="@/assets/examination/passed-icon.png" class="res-icon" alt="" v-if="examDetailData.writtenTest*1 === 1">
                <div class="top-shadow"></div>
                <div class="g-p-t-50">
                  <!--   不合格   -->
                  <p class="red-text g-font-26" v-if="examDetailData.writtenTest*1 === 2">{{ examDetailData.writtenScore + '分' }}</p>
                  <!--   合格   -->
                  <p class="green-text g-font-26" v-if="examDetailData.writtenTest*1 === 1">
                    {{ examDetailData.writtenScore + '分' }}</p>
                  <!--   未考试   -->
                  <p class="red-text g-font-26" v-if="examDetailData.writtenTest*1 === 0">您还未考试！</p>
                  <div class="g-m-t-35 sub-box g-m-l-26 g-m-r-26">
                    <div class="g-p-25">
                      <div class="g-flex g-row-between">
                        <p class="g-font-18 main-text">考试科目</p>
                        <p class="g-font-18 blue-text g-weight-font">{{ examDetailData.paperName }}</p>
                      </div>
                      <div class="g-flex g-row-between g-m-t-20">
                        <p class="g-font-18 main-text">考试方式</p>
                        <p class="g-font-18 blue-text g-weight-font">{{ examDetailData.examType }}</p>
                      </div>
                      <div class="g-flex g-row-between g-m-t-20">
                        <p class="g-font-18 main-text">满分</p>
                        <p class="g-font-18 blue-text g-weight-font">{{ examDetailData.totalScore }}分</p>
                      </div>
                      <div class="g-flex g-row-between g-m-t-20">
                        <p class="g-font-18 main-text">考试时长</p>
                        <p class="g-font-18 blue-text g-weight-font">{{ examDetailData.duration }}分钟</p>
                      </div>
                    </div>
                  </div>
                  <div class="g-m-t-25">
                    <!--   未考试   -->
                    <div class="g-flex g-row-center">
                      <div class="submit-btn g-font-16" @click="startTest(1)" v-if="examDetailData.writtenTest*1 === 0">
                        开始考试
                      </div>
                    </div>

                    <!--   不合格   -->
                    <div class="g-flex g-row-around g-p-l-30 g-p-r-30" v-if="examDetailData.writtenTest*1 === 2">
                      <div class="btn btn1" @click="toTestDetail">查看答卷</div>
                      <div class="btn submit-btn" @click="startTest(1)" >重新考试</div>
                    </div>
                    <!--   合格   -->
                    <div class="g-flex g-row-around g-p-l-30 g-p-r-30" v-if="examDetailData.writtenTest*1 === 1">
                      <div class="btn btn1" @click="showCert">查看证书</div>
                      <div class="btn btn1" @click="toTestDetail">查看答卷</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  线上实操考试  -->
      <div class="exam-item">
        <div class="g-flex g-row-center">
          <div class="g-text-center">
            <img src="@/assets/examination/xsscks-img.png" class="g-m-t-75 exam-title" style="width: 311px" alt="">
            <div>
              <img src="@/assets/examination/exam-cut-line.png" class="bar-line" alt="">
            </div>
            <div class="g-m-t-20">
              <img src="@/assets/examination/exam-box-bar.png" class="box-bar" alt="">
              <div class="info-box g-rela">
                <div class="info-box g-rela">
                  <!--   不合格图片   -->
                  <img src="@/assets/examination/failed-icon.png" class="res-icon" alt="" v-if="onLineOperation*1 === 2">
                  <!--   合格图片   -->
                  <img src="@/assets/examination/passed-icon.png" class="res-icon" alt="" v-if="onLineOperation*1 === 1">
                  <!--   考核中图片   -->
                  <img src="@/assets/examination/checking-icon.png" class="res-icon" alt="" v-if="onLineOperation*1 === 3">
                  <div class="top-shadow"></div>
                  <div class="g-p-t-50">
                    <!--   不合格   -->
                    <p class="red-text g-font-26" v-if="examDetailData.onLineOperation*1 === 2">不合格</p>
                    <!--   合格   -->
                    <p class="green-text g-font-26" v-if="examDetailData.onLineOperation*1 === 1">合格</p>
                    <!--   未考试   -->
                    <p class="red-text g-font-26" v-if="examDetailData.onLineOperation*1 === 0">您还未考试！</p>
                    <!--   考核中   -->
                    <p class="yellow-text g-font-26 g-font-weight-7" v-if="examDetailData.onLineOperation*1 === 3">考核中</p>
                    <div class="g-m-t-35 sub-box g-m-l-26 g-m-r-26">
                      <div class="g-p-25">
                        <div class="g-flex g-row-between">
                          <p class="g-font-18 main-text">考试科目</p>
                          <p class="g-font-18 blue-text g-weight-font">{{ examDetailData.paperName }}</p>
                        </div>
                        <div class="g-flex g-row-between g-m-t-20">
                          <p class="g-font-18 main-text">考试方式</p>
                          <p class="g-font-18 blue-text g-weight-font">上传视频</p>
                        </div>
                        <div class="g-flex g-row-between g-m-t-20">
                          <p class="g-font-18 main-text">等级</p>
                          <p class="g-font-18 blue-text g-weight-font">{{ examDetailData.testLevel }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="g-m-t-72">
                      <!--   未考试   -->
                      <div class="g-flex g-row-center">
                        <div class="submit-btn g-font-16"  @click="startTest(2)" v-if="examDetailData.onLineOperation*1 === 0&&examDetailData.writtenTest*1 === 1">
                          开始考试
                        </div>
                      </div>

                      <!--   不合格   -->
                      <div class="g-flex g-row-around g-p-l-30 g-p-r-30" v-if="examDetailData.onLineOperation*1 === 2">
                        <div class="btn btn1" @click="dialogVisible=true">查看考试视频</div>
                        <div class="btn submit-btn" @click="startTest(2)">重新考试</div>
                      </div>

                      <!--   合格   -->
                      <div class="g-flex g-row-around g-p-l-30 g-p-r-30" v-if="examDetailData.onLineOperation*1 === 1">
                        <div class="btn btn1" @click="dialogVisible=true">查看考试视频</div>
                        <div class="btn btn1" @click="showCert">查看证书</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  弹窗  -->
    <message-popup ref="popup" @submit="goPage('written-test')">
      <div class="g-text-center">
        <p class="main-text g-font-14">您确定开始考试吗？</p>
        <p class="g-m-t-10 remark-text g-font-12">确认后即开始考试</p>
      </div>
    </message-popup>
    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        width="50%">
      <div class="g-rela">
        <video id="media" height="500px"  width="100%" controls>
          <source :src="examDetailData.videoUrl" type="video/mp4">
        </video>
      </div>
      <div class="g-flex g-row-center g-m-t-30">
        <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import messagePopup from "@/components/message-popup";
export default {
  components:{
    messagePopup
  },
  name: "exam-card",
  props: {
    examDetailData:{
      type: Object
    },
   /* // 笔试状态
    writtenTest: {
      default: 0,//0未考试 1合格 2不合格
      type: Number || String
    },
    // 笔试分数
    writtenScore: {
      default: 60,
      type: Number || String
    },*/
  },
  data() {
    return {
      selected:'',
      dialogVisible:false
    }
  },

  methods:{
    startTest(val){
      this.selected = val

      if(!this.examDetailData.isStudyFinish){
        this.$msgbox("您还没学完该课程，请选学习后再进行考试！");
        return;
      }
      if(val === 1){
        this.$refs.popup.open()
      }else {
        this.goPage('online-operation')
      }
    },
    // 线上实操去考试
    goPage(name,val){
      this.$router.push({
        name:name,
        query:{
          paperId: this.examDetailData.paperId,
          testLevel: this.examDetailData.testLevel,
          paperName: this.examDetailData.paperName
        }
      })
    },
    toTestDetail(){
      this.$router.push({
        name:"written-test-detail",
        query: {
          paperId:this.examDetailData.paperId,
        }
      })
    },
    showCert(){
      this.$router.push({
        name:"mine",
        query: {
          menuIndex:6,
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  height: 720px;
  background: linear-gradient(180deg, #1f63ff 0%, #799dff 100%);
  border-radius: 20px;

  .exam-item {
    background-image: url("../../../assets/examination/exam-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 585px;
    height: 690px;
  }

  .info-box {
    width: 479px;
    height: 447px;
    background: #ffffff;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 4px 15px 0 rgba(32, 94, 238, 0.50);
    position: relative;
    margin: -15px auto 0 auto;

    .top-shadow {
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      width: 100%;
      height: 15px;
      background: linear-gradient(180deg, #6a94ff, rgba(125, 176, 255, 0.00) 100%);
    }
  }

  .sub-box {
    background: #f6f6f8;
    border-radius: 10px;
  }
}

.exam-title {
  width: 210px;
  height: 42px;
  margin: 0 auto;
}

.box-bar {
  width: 505px;
}

.bar-line {
  width: 218px;
  height: 38px;
  margin: 0 auto;
}

.submit-btn {
  padding: 13px 48px;
  font-size: 16px;
}

.res-icon {
  width: 70px;
  height: 70px;
  position: absolute;
  top: 28px;
  right: 40px;
  z-index: 22;
}

.btn {
  padding: 13px 48px;
  border-radius: 5px;
}

.btn1 {
  background: #f6f6f8;
  color: #407aff;
  font-size: 16px;

  &:hover {
    background: #407aff;
    color: #fff;
    cursor: pointer;
    transition: all ease-in 0.2s;
  }
}
</style>